<ll-titulo>Plan de Clase</ll-titulo>
<plan-clase
    [onlyShared]="true"
    [showButtonCompartir]="!disableCompartir"
    [enableReplicar]="!disableCompartir"
    [planPersonalId]="planPersonalId"
    [vistaPrevia]="vistaPrevia"
    [urlNavigate]="urlNavigate"
></plan-clase>
